import { HtmlHelper } from "./html.helper";

export class SearchHelper {
    static isSearchVesselIMO(vessel, filter) {

        if (isNaN(filter)) return false;
        
        let highlightedSyntax = '';

        if (vessel.internationalMaritimeOrganizationNumber) {
            highlightedSyntax = HtmlHelper.syntaxHighlight(
                filter, 
                vessel.internationalMaritimeOrganizationNumber);

            if (highlightedSyntax.indexOf('<b>') > -1) return true;
        }
        
        if (vessel.vehicleIdentificationNumber) {
            highlightedSyntax = HtmlHelper.syntaxHighlight(
                filter, 
                vessel.vehicleIdentificationNumber);

            if (highlightedSyntax.indexOf('<b>') > -1) return true;
        }
        
        if (vessel.europeanNumberOfIdentification) {
            highlightedSyntax = HtmlHelper.syntaxHighlight(
                filter, 
                vessel.europeanNumberOfIdentification);
                
            if (highlightedSyntax.indexOf('<b>') > -1) return true;
        }
           
        return false;
    }
}
